// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__25xSs","label":"Labeled_label__1Zj51","divider":"Labeled_divider__23Bg3"};